import { createRoot } from "react-dom/client";
import { Provider } from "react-redux";
import { store } from "./store/store";
import { App } from "./App";
import { I18nextProvider } from "react-i18next";
import i18next from "./translations/index";
import { SnackbarProvider } from "notistack";
//import UserWayScript from './components/UserWay/UserWay';
import {
  ethicsSuccess,
  ethicsError,
  ethicsInfo,
  ethicsWarning,
} from "./components/Flags/AlertFlags";
import useCustomTheme from "./theme/themeMUI/useCustomTheme";
import { AppProvider } from "./components/AppContext/AppContext";
import { CssBaseline, ThemeProvider } from "@mui/material";

// Silencia la advertencia benigna de ResizeObserver ("ResizeObserver loop ...")
// que dispara el navegador al re-medir contenido animado (p.ej. Collapse) y que
// el overlay de error de CRA muestra como si fuera un error grave.
const resizeObserverErrRegex = /ResizeObserver loop (limit exceeded|completed with undelivered notifications)/;
window.addEventListener("error", (e) => {
  if (e?.message && resizeObserverErrRegex.test(e.message)) {
    e.stopImmediatePropagation();
  }
});

const container = document.getElementById("root");
const root = createRoot(container);

const Main = () => {
  const theme = useCustomTheme();
  
  return (
    <ThemeProvider theme={theme}>
      <CssBaseline/>
      
      <SnackbarProvider
        Components={{
          success: ethicsSuccess,
          error: ethicsError,
          warning: ethicsWarning,
          info: ethicsInfo,
        }}
        maxSnack={5}
        autoHideDuration={5000}
      >
        <App tab="home" />
      </SnackbarProvider>
    </ThemeProvider>
  );
};

root.render(
  <Provider store={store}>
    <AppProvider>
      <I18nextProvider i18n={i18next}>
          <Main />
      </I18nextProvider>
    </AppProvider>
  </Provider>
);
